import React, { useContext } from 'react';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Picture } from '@comparethemarketau/manor-picture';
import { getAssetFilePath } from '../../summary/common/get_asset_file_path';

const useStyles = createUseStyles((theme) => ({
    icon: {
        width: '11rem',
        height: '11rem'
    }
}));

const MagnifierIcon = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const imgSrc = getAssetFilePath('/assets/brand/ctm/images/empty_state.png');

    return (
        <Picture className={classes.icon} src={imgSrc} alt={'Adjust your search by updating your filters'} />
    );
};

export { MagnifierIcon };
